/** In this file contains the landing page UI designs and functionality **/
import constantVariables from './../../dataset/constantVariables.json';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import * as Yup from 'yup';
import { validate } from './../../services/ValidationService';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ApiService from './../../services/ApiService';
import { toast } from 'react-toastify';

//Landing or Home page
export default function RequestDemo(){

	//Intial state declaration
	const [data,setData]=useState({});
	const [error,setError]=useState({});
	const [isValid,setIsValid]=useState(true);
	const navigate = useNavigate();
	
	//validate patterns
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** 
	* Validation schema for Physician Fields
	* @first_name - required field and pass the physician first_name
	* @last_name - required field and pass the physician last_name
	* @email - required field and should be in correct physician email format 
	* @mobileNumber - required field and pass the physician mobileNumber
	* @Clinic Name - required field and pass the physician's Clinic Name
	* @Message - required field and pass the physician Message
	**/
   const fields = [
    { name: 'first_name', validation: Yup.string().required(constantVariables.error.required) },
    { name: 'last_name', validation: Yup.string().required(constantVariables.error.required) },
	{ name: 'email', validation: Yup.string().test('Invalid email address', constantVariables.error.email, (value) => { return emailPattern.test(value); }).required(constantVariables.error.email)},
	{ name: 'mobileNumber', validation: Yup.string().required(constantVariables.error.required) },
	{ name: 'clinic_name', validation: Yup.string().required(constantVariables.error.required)},
	{ name: 'message', validation: Yup.string().min(25, constantVariables.error.message).required()},
   ];

	/** 
   * To handle input change event 
   * @e - we get the event details from the Change action
   **/
   const handleChange=async(e)=>{
	   const {name,value}=e.target;
	   e.preventDefault();
	   setData({...data,[name]:value});
	   const Errors=await validate({[name]:value},fields);
	   setError({...error,[name]:Errors[name]});
   }
   
	/** 
	  * To check phone number valid or not 
	  * @value - we pass the actual phone number
	  * @country - we pass the countryCode
	  * @e - we get the event details from the onChange action
	  * @formattedValue - we pass the country formatted Value
	  **/
   const handlePhone=async (value,country:any,e,formattedValue)=>{
	   const {format, dialCode} = country;
		setData({...data,[e.target.name]:formattedValue.split("+"+dialCode+" ")[1],countryCode:'+'+dialCode});
      const Errors = await validate({ [e.target.name]: formattedValue }, fields);
      setError({...error,[e.target.name]:Errors[e.target.name]});
      if (format?.length === formattedValue?.length && (value.startsWith(dialCode) || dialCode.startsWith(value))) {
	       setIsValid(true);
	  }else{
		   setIsValid(false);
	  }
   }

	/** 
	   * To handle the form submit event 
	   * @e - we get the event details from the form submit action
	   **/	
	  const handleSubmit=async(e)=>{
		  e.preventDefault();
		  const Errors=await validate(data,fields)
		  setError(Errors);
		 if(!Object.keys(Errors).length && isValid){
			var response = await ApiService.requestDemo(data);
			  if(response?.status===200){
				toast.success(response?.data?.message);
				navigate('/');  
			  }else{
				  toast.error(response?.data?.message ? response?.data?.message : 'Some Thing Went Wrong Try Again!');
			  }
		  }	  
	  }
   
	return (
	<> <div id="indexPage">
	{/*Breadcrumb Section*/}
	<section id="BreadcrumbSec" className="d-flex align-items-center justify-content-center">
		<div className="container">
			<div className="row d-flex">
				<div className="col-lg-12 align-items-center">
					<h1>{constantVariables.landing.requestDemo}</h1>
				</div>
			</div>
		</div>
	</section>
	
	{/*About Section*/}
	<section className="section">
		<div className="container">
			<div className="row mb-4"> 
				<div className="col-lg-12 text-center">  
					<h2 className="fw-bold">{constantVariables.landing.demoTxt1}</h2>
					<h4>{constantVariables.landing.demoTxt2}</h4>
				</div>	
			</div>
			
			<div className="row justify-content-center">
				<div className="col-md-12 col-lg-10">
					<div className="wrap d-md-flex">
						<img src="assets/img/RequestDemoImg.jpg" className="w-50 d-md-none d-lg-block" alt="img" />
						
						{/*Login*/}					
						<div id="loginForm" className="w-100" style={{"background":"#f5f5f5","borderRadius":"0"}}>
							<form autoComplete="off">
								<div className="form-group">
									<label className="mb-1">{constantVariables.profile.firstName}</label>
									<input type="text" onChange={handleChange}  value={data.first_name?data.first_name:''} name="first_name" className="form-control" placeholder={constantVariables.profile.firstName} />
									<i className="iconly-Light-User"></i>
									{error && error.first_name && <span className="required">{error.first_name}</span>}
								</div>
								<div className="form-group">
									<label className="mb-1">{constantVariables.profile.lastName}</label>
									<input type="text" onChange={handleChange}  value={data.last_name?data.last_name:''} name="last_name" className="form-control" placeholder={constantVariables.profile.lastName} />
									<i className="iconly-Light-User"></i>
									{error && error.last_name && <span className="required">{error.last_name}</span>}
								</div>
								<div className="form-group">
									<label className="mb-1">{constantVariables.profile.emailAddress}</label>
									<input type="email" onChange={handleChange}  value={data.email?data.email:''} name="email" className="form-control" placeholder={constantVariables.profile.emailAddress} />
									<i className="iconly-Light-Message"></i>
									{error && error.email && <span className="required">{error.email}</span>}
								</div>	
								<div className="form-group">
									<label className="mb-1">{constantVariables.profile.phoneNumber} </label>
									<PhoneInput
									  inputClass="custom-phone-input"
									  inputProps={{
									  name: 'mobileNumber',
									  style: { width: '100%'}
									  }}
									  country={'us'}
									   onChange={handlePhone}
									/>
									{error && error.mobileNumber && <span className="required">{error.mobileNumber}</span>}
									{!isValid && !error.mobileNumber && <span className="required">Enter Valid Number</span>}
								</div>	
								<div className="form-group">
									<label className="mb-1">{constantVariables.landing.clinicName}</label>
									<input type="text" onChange={handleChange}  value={data.clinic_name?data.clinic_name:''} name="clinic_name" className="form-control" placeholder={constantVariables.landing.clinicName} />
									<i className="iconly-Light-Plus"></i>
									{error && error.clinic_name && <span className="required">{error.clinic_name}</span>}
								</div>	
								<div className="form-group">
									<label className="mb-1">{constantVariables.profile.message}</label>
									<textarea onChange={handleChange}  value={data.message?data.message:''} name="message" className="form-control"rows="4" placeholder={constantVariables.profile.message}></textarea>
									<i className="iconly-Light-Chat"></i>
									{error && error.message && <span className="required">{error.message}</span>}
								</div>				
								<div className="mb-5 mt-3">
									<button onClick={handleSubmit} type="button" className="btn btn-tmBlue w-100">{constantVariables.profile.submit}</button>
								</div>
							</form>
						</div>
						{/*End Login Form*/}
					</div>
				</div>
			</div>
		</div>
	</section>
	</div></>);
}